/**
 * Nav View
 *
 * @module components/Nav/Nav
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { NavThemes } from '../../../src/constants/App';
import QA from '../../constants/QATags';
// Added here.  Delete comment after resolve.
import { AsyncDomain } from '../../domains';

import NavPrimary from './NavPrimary';
import NavSecondary from './NavSecondary';

import './Nav.scss';

export default class Nav extends React.PureComponent {
  static propTypes = {
    openDropdown: PropTypes.func,
    pathname: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    navPrimaryTheme: PropTypes.string.isRequired,
    navSecondaryTheme: PropTypes.string,
    listenerImgUrl: PropTypes.string,
    stationId: PropTypes.string,
    branding: PropTypes.string.isRequired,
    isAnonymous: PropTypes.bool.isRequired,
    isScrolled: PropTypes.bool.isRequired,
    activeAdSkinName: PropTypes.string,
    isAdSkinClassAppliedToElement: PropTypes.bool,
    isRightRailActive: PropTypes.bool,
    showPremiumFeatures: PropTypes.bool,
    currentMyCollectionPath: PropTypes.string,
    nowPlayingPath: PropTypes.string,
    browsePath: PropTypes.string,
    backgroundColor: PropTypes.string,
    isSearchOpen: PropTypes.bool.isRequired,
    showTopNav: PropTypes.bool,
    showSearchInHeader: PropTypes.bool,
    showColdStart: PropTypes.bool,
    productTierIsAdSupported: PropTypes.bool,
    productTierIsPlus: PropTypes.bool,
    isSafari: PropTypes.bool,
    isCollectionEmpty: PropTypes.bool,
    signUpClicked: PropTypes.func,
    logInClicked: PropTypes.func,
    hasCurrentTrack: PropTypes.bool,
  };

  render() {
    const {
      backgroundColor,
      isScrolled,
      showPremiumFeatures,
      isAdSkinClassAppliedToElement,
      isRightRailActive,
      isSearchOpen,
      showTopNav,
      showSearchInHeader,
      showColdStart,
      isSafari,
      isCollectionEmpty,
    } = this.props;
    const style = backgroundColor ? { backgroundColor } : {};
    const navClasses = classNames('Nav', `Nav--${this.props.theme}Theme`, {
      'Nav--premium': showPremiumFeatures,
      'Nav--standard': !showPremiumFeatures,
      'Nav--scrolled': isScrolled,
      'Nav--rightRail': isRightRailActive,
      [`adSkin-nav--${this.props.activeAdSkinName}`]: isAdSkinClassAppliedToElement,
      'adSkin-nav--rightRail': isAdSkinClassAppliedToElement && isRightRailActive,
      [`adSkin-nav--scrolled--${this.props.activeAdSkinName}`]:
        isAdSkinClassAppliedToElement && isScrolled,
      'Nav--safari': isSafari,
    });

    return (
      <div className={navClasses} style={style}>
        <NavPrimary
          pathname={this.props.pathname}
          showPremiumFeatures={this.props.showPremiumFeatures}
          currentMyCollectionPath={this.props.currentMyCollectionPath}
          nowPlayingPath={this.props.nowPlayingPath}
          browsePath={this.props.browsePath}
          isDark={
            showColdStart
              ? true
              : isSearchOpen
              ? false
              : this.props.navPrimaryTheme === NavThemes.DARK
          }
          qaTagNowPlaying={QA.HNPL}
          qaTagMyStations={QA.HMSL}
          isCollectionEmpty={this.props.isCollectionEmpty}
          hasCurrentTrack={this.props.hasCurrentTrack}
        />
        {showSearchInHeader && showTopNav && (
          <AsyncDomain
            domain='searchT3'
            key='SearchT3Modal'
            component='SearchModal'
            showColdStart={showColdStart}
            initialFocus={isCollectionEmpty && isSearchOpen}
          />
        )}
        <NavSecondary
          openDropdown={this.props.openDropdown}
          theme={this.props.navSecondaryTheme}
          listenerImgUrl={this.props.listenerImgUrl}
          nowPlayingPath={this.props.nowPlayingPath}
          branding={this.props.branding}
          isAnonymous={this.props.isAnonymous}
          isScrolled={this.props.isScrolled}
          isRightRailActive={this.props.isRightRailActive}
          productTierIsAdSupported={this.props.productTierIsAdSupported}
          productTierIsPlus={this.props.productTierIsPlus}
          showColdStart={showColdStart}
          isSearchOpen={this.props.isSearchOpen}
          signUpClicked={this.props.signUpClicked}
          logInClicked={this.props.logInClicked}
        />
      </div>
    );
  }
}
